import { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { useAuth0 } from "@auth0/auth0-react";
import "./App.css";
import "./css/common.css";
import "./css/wizard.css";
import { MainLayout } from "./components/layouts/MainLayout";
import { IntercomProps, IntercomProvider } from "react-use-intercom";
import {getBagelId, getConnectedUserRole, getIntercomInitPropsForUser, isBagelAdmin} from "./utils";
import VerifyEmail from "./VerifyEmail";
import { IdeasWraper } from "./components/ideas";
import  { SyncContextProvider } from "./context/SyncContext";

import { usePostHog } from "posthog-js/react";
import UnauthorizedMessage from "./UnauthorizedMessage";

import { routes } from './routes/index';
import { listFields } from "./Api";

TimeAgo.addDefaultLocale(en);

function App() {
  const auth0 = useAuth0();
  const posthog = usePostHog();
  const [fields, setFields] = useState<any>(null);
  useEffect(() => {
    if (auth0.user) {
      const userId = getBagelId(auth0.user);

      if (posthog && window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN !== 'http://localhost') {
        posthog.identify(userId, {
          ...auth0.user,
          email: auth0.user.email,
        });
      }
    }
    listFields(auth0).then((fields) => {
      setFields(fields.subPages);
    });

  }, [auth0]);

  if (
    (auth0.isLoading === undefined && auth0.isAuthenticated === undefined) ||
    auth0.isLoading
  ) {
    return <div>Loading...</div>;
  }
  if (!auth0.isLoading && !auth0.isAuthenticated) {
    auth0.loginWithRedirect();
    return <div>Redirecting to login...</div>;
  } else {
    posthog?.capture("logged_in");
  }

  const forceEmailVerification =
    window.__RUNTIME_CONFIG__.REACT_APP_FORCE_VERIFY_EMAILS === "true";
  if (forceEmailVerification && auth0.user?.email_verified !== true) {
    return <VerifyEmail />;
  }

  const userRole = getConnectedUserRole(auth0);
  
  const bagelId = getBagelId(auth0.user);
  if (!bagelId || !["admin", "manager", "agent"].includes(userRole)) {
    return <UnauthorizedMessage />;
  }
  const bagelAdmin = isBagelAdmin(auth0.user) && userRole === "admin";
  const intercomInitProps: IntercomProps = getIntercomInitPropsForUser(
    auth0.user
  );
  
  return (
    <Router>
      <IntercomProvider
        appId={window.__RUNTIME_CONFIG__.REACT_APP_INTERCOM_APP_ID}
        autoBoot={true}
        autoBootProps={intercomInitProps}
      >
        <SyncContextProvider>
          <MainLayout>
            <Routes>
              {routes.map((route: any) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                >
                  {route.children?.map((childRoute: any) => (
                    <Route
                      key={childRoute.path}
                      path={childRoute.path}
                      element={childRoute.element}
                    />
                  ))}
                </Route>
              ))}
              {fields?.map((route: any) => (
                <Route
                  key={route.route}
                  path={`/ideas/${route.route}`}
                  element={<IdeasWraper pageKey={route} />}
                />
              ))}
                           
            </Routes>
          </MainLayout>
        </SyncContextProvider>
      </IntercomProvider>
    </Router>
  );
}

export default App;
